import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { MobileAppComponent } from './components/mobile-app/mobile-app.component';
import { PlayerProfileComponent } from './components/player-profile/player-profile.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { StripeComponent } from './components/stripe/stripe.component';
import { HowToComponent } from './components/how-to/how-to.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { ProductsComponent } from './components/products/products.component';
import { AdminGuard } from './guards/admin.guard';
import { PricingComponent } from './components/pricing/pricing.component';
import { TermsComponent } from './components/terms/terms.component';
import { ReturnsComponent } from './components/returns/returns.component';
import { TryItFreeComponent } from './components/try-it-free/try-it-free.component';
import { PreloadAllModules } from '@angular/router';
import { BossGolfComponent } from './components/boss-golf/boss-golf.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { RegisterComponent } from './components/register/register.component';
import { PlayerLookupComponent } from './components/player-lookup/player-lookup.component';
import { MatchPlayComponent } from './components/match-play/match-play.component';
import { SkinsComponent } from './components/skins/skins.component';
import { ScorecardLookupComponent } from './components/scorecard-lookup/scorecard-lookup.component';
import { BillingComponent } from './modules/shared/billing/billing.component';
import { HandicapPlusComponent } from './components/handicap-plus/handicap-plus.component';
import { NoPreloading } from '@angular/router';

const routes: Routes = [
  { pathMatch: "full", path: "", component: HomeComponent },
  { path: "group", loadChildren: () => import('./modules/group-console/group-console.module').then(m => m.GroupConsoleModule) },
  { path: "results", loadChildren: () => import('./modules/results/results.module').then(m => m.ResultsModule) },
  { path: "dashboard", loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: "upgrade", loadChildren: () => import('./modules/upgrade/upgrade.module').then(m => m.UpgradeModule) },
  { path: "event", loadChildren: () => import('./modules/event/event.module').then(m => m.EventModule) },
  { path: "admin", loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule), canActivate: [AdminGuard] },
  { path: "clubs", loadChildren: () => import('./modules/clubs/clubs.module').then(m => m.ClubsModule) },
  { path: "leaderboard", loadChildren: () => import('./modules/leaderboard/leaderboard.module').then(m => m.LeaderboardModule) },
  { path: "join", loadChildren: () => import('./modules/join/join.module').then(m => m.JoinModule) },
  { path: 'event-builder', loadChildren: () => import('./event-experience/event-experience.module').then(m => m.EventExperienceModule) },
  { pathMatch: "full", path: "handicap-plus", component: HandicapPlusComponent },
  { pathMatch: "full", path: "billing/plans", component: BillingComponent },
  { pathMatch: "full", path: "privacy", component: PrivacyComponent },
  { pathMatch: "full", path: "scorecard/:course_id", component: ScorecardLookupComponent },
  { pathMatch: "full", path: "player-lookup", component: PlayerLookupComponent },
  { pathMatch: "full", path: "player-lookup/:player_id", component: PlayerLookupComponent },
  { pathMatch: "full", path: "skins/:group_event_id", component: SkinsComponent },
  { pathMatch: "full", path: "notifications", component: NotificationsComponent }, //
  { pathMatch: "full", path: "terms", component: TermsComponent },
  { pathMatch: "full", path: "returns", component: ReturnsComponent },
  { pathMatch: "full", path: "products", component: ProductsComponent },
  { pathMatch: "full", path: "pricing", component: PricingComponent },
  { pathMatch: "full", path: "how-to", component: HowToComponent },
  { pathMatch: "full", path: "profile", component: PlayerProfileComponent }, //
  { pathMatch: "full", path: "match-play", component: MatchPlayComponent },
  { pathMatch: "full", path: "golf-mobile-app", component: MobileAppComponent },
  { pathMatch: "full", path: "stripe", component: StripeComponent },
  { pathMatch: "full", path: "login", component: LoginComponent },
  { pathMatch: "full", path: "logout", component: LogoutComponent },
  { pathMatch: "full", path: "register", component: RegisterComponent },
  { pathMatch: "full", path: "register/league", component: RegisterComponent },
  { pathMatch: "full", path: "register/tournament", component: RegisterComponent },
  { pathMatch: "full", path: "register/trip", component: RegisterComponent },
  { pathMatch: "full", path: "tryitfree", component: TryItFreeComponent },
  { pathMatch: "full", path: "bossgolf", component: BossGolfComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, preloadingStrategy: NoPreloading })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
